import { render, staticRenderFns } from "./WithSideBar.vue?vue&type=template&id=455326d8&scoped=true&"
import script from "./WithSideBar.vue?vue&type=script&lang=js&"
export * from "./WithSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455326d8",
  null
  
)

export default component.exports